import React from 'react'
import styled from 'styled-components'

const PanelContainer = styled.div`
  position: relative;
`

const PanelBackground = styled.div`
  position: absolute;
  width: 100vw;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);

  &.variant-light {
    background-color: ${props => props.theme.palette.neutral.eight};
  }

  &.variant-grey {
    background-color: ${props => props.theme.palette.neutral.six};
  }
`

const ChildrenRiser = styled.div`
  transform: translateZ(0);
`

interface Props {
  children: React.ReactNode;
  className?: string;
  variant: 'light' | 'grey';
}

/**
 * This component is for when you want to have a different background
 * for an offer list item that spans the full width, not just inside the layout container
 */
function OfferListFullWidthPanel(props: Props) {
  const { children, className, variant } = props

  return <PanelContainer className={className}>
    <PanelBackground className={`variant-${variant}`} />
    <ChildrenRiser>
      {children}
    </ChildrenRiser>
  </PanelContainer>
}

export default OfferListFullWidthPanel
